import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HeaderComponent } from '../../../shared/layout/app/header/header.component';
import { CommonModule } from '@angular/common';
import { AuthBllService } from '../../auth/auth-bll.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { ProfileBllService } from '../../profile/profile-bll.service';
import { UserService } from '../../../core/services/user.service';
import { UserEventStatusRespModel } from '../../profile/profile.model';
import { APIErrorModel, BaseResponse } from '../../../shared/models/base-response.model';
import { HomeBllService } from '../../home/home-bll.service';
import { PavilionGroupModel, PavilionModel } from '../../digital-catalogue/digital-catalogue.model';
import { DigitalCatalogueBllService } from '../../digital-catalogue/digital-catalogue-bll.service';
import { EventDetailsResponseModel } from '../../home/home.model';

type PosClass = '' | 'active' | 'left1' | 'left2' | 'right1' | 'right2';

@Component({
  selector: 'app-promotion-marathi',
  imports: [HeaderComponent, CommonModule, RouterLink],
  templateUrl: './promotion-marathi.component.html',
  styleUrls: ['./promotion-marathi.component.scss']
})
export class PromotionMarathiComponent implements OnInit, AfterViewInit, OnDestroy {

  // User authentication status
  isAuthenticated: boolean = false;
  userProfile: UserEventStatusRespModel["user_profile"] | null = null;
  previewLogo: string = "/assets/images/Default-profile-photo.png"; // String path/URL

  // Ticket assignment status
  isAssigned: boolean = false;
  refSource: string = '';

  /**
   * Pavilion related properties
   */
  pavilionGroups: PavilionGroupModel[] = []; // List of pavilion groups
  allPavilions: PavilionModel[] = []; // Flattened list of all pavilions
  isLoadingPavilions: boolean = false;
  hidePavilionSection: boolean = false;

  isContestActive : boolean = false;
  isVotingActive : boolean = false;

  eventDetails : EventDetailsResponseModel | null = null;

  @ViewChildren('homeVideo') homeVideos!: QueryList<ElementRef<HTMLVideoElement>>;

  logos = [
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/agri.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/water.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/plasti.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/tools.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/open.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/kisan-in/pavilion_images/app/urjaa-inner.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/vatika.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/green.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/event/pune24/pavilion/interprise.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/kisan-in/pavilion_images/app/smart_border.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/kisan-in/pavilion_images/app/auto_green.png' },
    { img: 'https://kisan-common.s3.ap-south-1.amazonaws.com/kisan-in/pavilion_images/app/sports_green.png' },
  ];

  slides = [
    {
      title: 'सर्व दिवसांचा पास',
      icon: '/assets/images/me/allday_icon.png',
      class: 'allDay',
      points: [
        'किसान २०२५ च्या सर्व ५ दिवसांसाठी प्रवेश',
        'तुमच्या सोयीप्रमाणे संपूर्ण प्रदर्शन पाहा आणि कोणतीही गोष्ट अनुभवायची राहू देऊ नका!',
      ],
    },
    {
      title: 'बिझनेस पास',
      icon: '/assets/images/me/business_icon.png',
      class: 'business',
      points: [
        'सर्व ५ दिवसांसाठी आणि नेटवर्किंग आणि B2B साठीच्या विशेष दालनामध्ये प्रवेश',
        'व्यावसायिक, स्टार्टअप्स आणि उद्योगजगतातील तज्ञांसाठी खास पास',
      ],
    },
    {
      title: 'मुलांचे तिकीट',
      icon: '/assets/images/me/child_icon.png',
      class: 'child',
      points: ['एका दिवसासाठी एकदाच प्रवेश', 'पालक सोबत असणे आवश्यक'],
    },
    {
      title: 'पहिल्या दिवशीचं तिकीट',
      icon: '/assets/images/me/firstday_icon.png',
      class: 'firstDay',
      points: ['फक्त पहिल्या दिवसासाठी', 'किसान २०२५ प्रदर्शनाला भेट देणाऱ्या पहिल्या काहीजणांपैकी एक व्हा!'],
    },
    {
      title: 'एक दिवसीय तिकीट',
      icon: '/assets/images/me/single_icon.png',
      class: 'singleEntry',
      points: ['कोणत्याही एका दिवसासाठी एकदाच प्रवेश', 'प्रदर्शनाच्या कोणत्याही दिवशी भेट देऊ इच्छिणाऱ्यांसाठी'],
    },
  ];

  index = 0;
  slidePositions: PosClass[] = [];
  intervalId: any = null;
  readonly intervalMs = 4000;

  get total() {
    return this.slides.length;
  }
  
  showBuyTicketButton: boolean = false;

  constructor(
    private authService: AuthBllService,
    private router: Router,
    private loader: LoaderService,
    private profileBll: ProfileBllService,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private bllService: HomeBllService,
    private catalogueBllService: DigitalCatalogueBllService,
  ) { }


  ngAfterViewInit(): void {
    this.homeVideos.forEach(videoRef => {
      const video = videoRef.nativeElement;
      video.muted = true; // Ensure muted
      video.play();
    });
  }

  ngOnInit(): void {
    this.authService.isAuthenticated$.subscribe((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });

    this.refSource = this.getRefSourceFromRoute();

    if (this.refSource && this.refSource !== '') {
      this.bllService.homeInitStorageChanges('', this.refSource);
    } else {
      console.warn("homeInitStorageChanges not called due to missing data");
    }

    if (this.isAuthenticated) {
      this.fetchUserEventStatus();
    }
    this.startAutoSlide();
    this.initPositions();

    this.loadEventDetails();
  }

  getRefSourceFromRoute(): string {
    const refSource =
      this.activatedRoute.snapshot.queryParamMap.get("ref_source");
    if (!refSource) {
      console.error("Ref source not found in route parameters");
      return "";
    }
    return refSource;
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  fetchUserEventStatus() {
    this.loader.show();
    this.profileBll
      .submitGetUserEventStatus()
      .then((res: BaseResponse<UserEventStatusRespModel>) => {
        this.userProfile = res.data.user_profile;
        if (this.userProfile) {
          if (this.userProfile.image_url) {
            this.previewLogo =
              this.userProfile.image_url ??
              "/assets/images/Default-profile-photo.png";
          }

          let userName =
            res.data.user_profile.first_name +
            " " +
            res.data.user_profile.last_name;
          this.userService.setUser({
            name: userName, // get from API or JWT
            profileImg: this.previewLogo, // fallback if empty
            mobile: res.data.user_profile.mobile,
            state: res.data.user_profile.state,
            city: res.data.user_profile.city,
            hasUnassignedTickets: res.data.event_my_tickets.unassigned_tickets_bought_by_me > 0,
            hasAssignedTickets: res.data.event_my_tickets.assigned_tickets_bought_by_me > 0 || res.data.event_my_tickets.tickets_assigned_for_me > 0,
          });

          const assignedForMe = res.data.event_my_tickets.tickets_assigned_for_me;
          const assigned = res.data.event_my_tickets.assigned_tickets_bought_by_me;
          this.isAssigned = (assignedForMe ?? 0) > 0 || (assigned ?? 0) > 0;
        }
        this.loader.hide();
      })
      .catch((err: APIErrorModel) => {
        this.loader.hide();
        // error handled in profileBll already
      });

  }

  onBuyTickets(): void {
    if (!this.isAuthenticated) {
      this.authService.saveStorageValue('state', 'reg/select-ticket');
    }
    this.router.navigate(['reg/select-ticket']);
  }

  initPositions() {
    // set initial empty positions then compute
    this.slidePositions = new Array(this.total).fill('') as PosClass[];
    this.updatePositions();
  }


  updatePositions() {
    const total = this.total;
    const idx = this.index;

    // reset
    this.slidePositions = new Array(total).fill('') as PosClass[];

    const left2 = (idx - 2 + total) % total;
    const left1 = (idx - 1 + total) % total;
    const right1 = (idx + 1) % total;
    const right2 = (idx + 2) % total;

    this.slidePositions[idx] = 'active';
    this.slidePositions[left1] = 'left1';
    this.slidePositions[left2] = 'left2';
    this.slidePositions[right1] = 'right1';
    this.slidePositions[right2] = 'right2';
  }

  startAutoSlide() {
    this.clearAutoInterval();
    this.intervalId = setInterval(() => {
      this.index = (this.index + 1) % this.total;
      this.updatePositions();
    }, this.intervalMs);
  }

  pauseAutoSlide() {
    this.clearAutoInterval();
  }

  clearAutoInterval() {
    if (this.intervalId != null) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  next() {
    this.index = (this.index + 1) % this.total;
    this.updatePositions();
    this.restartTimer();
  }

  prev() {
    this.index = (this.index - 1 + this.total) % this.total;
    this.updatePositions();
    this.restartTimer();
  }

  restartTimer() {
    // restart auto sliding after manual nav
    this.clearAutoInterval();
    this.startAutoSlide();
  }

  onClickMobilePass() {
    if (!this.isAuthenticated) {
      this.authService.saveStorageValue('state', 'catalogue/pavilion-list');
    }
    this.router.navigate(['catalogue/pavilion-list']);
  }

  /**
  * Fetches the pavilion list from the BLL service.
  */
  callfetchPavilionList() {
    this.isLoadingPavilions = true;
    this.catalogueBllService
      .fetchPavilionList()
      .then((response) => {
        this.isLoadingPavilions = false;
        this.pavilionGroups = response.data.pavilion_groups;

        // Flatten all pavilion groups into one unified list
        this.allPavilions = this.pavilionGroups.flatMap(
          (group) => group.pavilions
        );

        this.hidePavilionSection = false;
      })
      .catch((error) => {
        this.isLoadingPavilions = false;
        console.error("Error fetching pavilion data:", error);
        if (error.status === 410) {
          // hide pavilion section
          this.hidePavilionSection = true;
        }
      });
  }

  onClickCatalog(pavilion: any): void {
    this.catalogueBllService.saveSelectedPavilionDetails(
      pavilion.code,
      pavilion.name,
      pavilion.pavilion_hover_image_url
    );
    this.router.navigate(["/catalogue/products-list"], {
      queryParams: { pavilion_code: pavilion.code },
    });
  }

  onClickVote(): void {
    this.router.navigate(['contests/participants-list']);
  }

  /**
   * Load event details such as contest and voting status
   */
  loadEventDetails() {
  this.bllService.fetchEventDetails()
    .then((response) => {
      this.eventDetails = response.data;
      this.isContestActive = this.eventDetails.is_contest_active;
      this.isVotingActive = this.eventDetails.is_voting_active;

      if (this.eventDetails.allow_to_register === 1 && this.eventDetails.event_status !== 'over') {
          this.showBuyTicketButton = true;
        } else {
          this.showBuyTicketButton = false;
        }

      if(this.eventDetails.show_digital_catalog) {
        // Fetch pavilion list
        this.callfetchPavilionList();
      }
    })
    .catch((error) => {
      console.error('Error fetching event details:', error);
    });
  }

}
